import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';
import { UserModel } from '@fi-app/user/user.model';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import {
    DataFieldEditCalendarComponent_Settings,
    TDataFieldEditCalendarComponent_Settings,
} from '@fi-app/data-field/data-field-edit/custom-calendar/custom-calendar.component';

@Component({
    selector: 'fi-user-edit-other-tab',
    templateUrl: './fi-user-edit-other-tab.component.html',
    styleUrls: ['./fi-user-edit-other-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-user-edit-other-tab' },
    providers: [
        {
            provide: DataFieldEditCalendarComponent_Settings,
            deps: [FiUserEditOtherTabComponent],
            useFactory: (): TDataFieldEditCalendarComponent_Settings => ({
                isOutlineLayout: true,
            }),
        },
        { provide: FiComponentsContainer, useExisting: FiUserEditOtherTabComponent },
    ],
    standalone: false,
})
export class FiUserEditOtherTabComponent extends FiComponentsContainer {
    @Input() dataFieldsCustom: DataFieldModel[] = [];
    @Input() user: UserModel;
}
